var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-app-bar',{attrs:{"app":"","color":"secondary","dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.$t("fundBaseForm.title"))+" ")])],1),_c('BaseForm',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }